import React from 'react'
import privacyPolicyHtml from './privacyPolicyHtml'

function PrivacyPolicyClassCopilot() {
  return (
    <div dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }} />
  )
}

export default PrivacyPolicyClassCopilot